import {axiosApiCall, axiosApiCallWithToken} from "../axios/customInstance";

export const getAllMedicalStaff = async () => {
    const url = "/medicalStaff";

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const getMedicalStaffById = async (staffId) => {
    const url = `/medicalStaff/${staffId}`;

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const updateDoctorProfile = async (staffId, updateData) => {
    const url = `/medicalStaff/${staffId}`;

    try {
        return await axiosApiCallWithToken.put(url, updateData);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const updateDoctorPassword = async (staffId, currentPassword, newPassword) => {
    const url = `/medicalStaff/${staffId}/password`;
    
    const passwordData = {
        currentPassword: currentPassword,
        newPassword: newPassword
    };

    try {
        return await axiosApiCallWithToken.put(url, passwordData);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const getAllDoctors = async () => {
    const url = "/allDoctors";

    return await axiosApiCallWithToken.get(url);

};

export const getActiveDoctorCount = async () => {
    const url = "/countActiveDoctors";

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const postDoctorRequest = async (request) => {
    const url = "/register-doctor";

    try {
        return await axiosApiCall.post(url, request);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const getPendingDoctorRequests = async () => {
    const url = "/get-pending-doctor-requests";
    return await axiosApiCallWithToken.get(url);
};

export const postAcceptedDoctorRequest = async (request) => {
    const url = "/addDoctor";

    try {
        return await axiosApiCallWithToken.post(url, request);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};


export const putRefusedDoctorRequest = async (requestId) => {
    const url = "/refuseDoctorRequest?requestId=" + requestId;
    try {
        return await axiosApiCallWithToken.post(url, requestId);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

export const putDeactivateDoctorRequest = async (email) => {
    const url = "/deactivate_medicalStaff?email=" + email;
    try {
        return await axiosApiCallWithToken.put(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};